import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import {
  AuthWrapper,
  FormWrapper,
  ContentLogin,
  ImageWrapper,
  Form,
  ConfirmWrapp,
  LinkWrap,
  EmptyColumn,
} from "../../style/Auth";

import logo from "../../images/ic_logo.svg";
import Button from "../../components/button/index";
import { ACCESS_SUSPENDED_STORAGE_KEY } from "../../config/api";

// Target of the 402 ORGANIZATION_SUSPENDED branch in src/config/api.js: the
// player's organization (club / agency) stopped paying, so every player
// under it lost access (plan §5.7, decision 5). Self-serve remains open to
// them (decision 6).
const readSuspension = () => {
  try {
    const raw = sessionStorage.getItem(ACCESS_SUSPENDED_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

const PlayerAccessSuspended = () => {
  const data = useMemo(readSuspension, []);
  const org = data?.organization || {};
  const isClub = org.kind === "club" || data?.billing_track === "club";
  const noun = isClub ? "club" : "organization";
  const name = org.name || (isClub ? "Your club" : "Your organization");
  const contact = org.contact_email;

  return (
    <AuthWrapper>
      <FormWrapper>
        <ContentLogin>
          <EmptyColumn />
          <Form as="div">
            <a href="/">
              <img className="logo" src={logo} alt="Logo" />
            </a>
            <h1>{name}'s SmrtStats access has ended</h1>
            <p>
              Your access to the Player App was provided by your {noun}, and it
              is currently switched off. Ask your {noun} about renewing
              {contact ? (
                <>
                  {" "}— <a href={`mailto:${contact}`}>{contact}</a>
                </>
              ) : null}
              .
            </p>
            <p>
              Want to keep using SmrtStats on your own? You can subscribe
              individually for €69/month.
            </p>
            <ConfirmWrapp>
              <Link to="/player/register" style={{ textDecoration: "none" }}>
                <Button
                  title="Subscribe individually"
                  size="full"
                  sizeResponse="full"
                  type="button"
                />
              </Link>
            </ConfirmWrapp>
          </Form>
          <LinkWrap>
            <h3>
              <Link to="/login">Log in with a different account</Link>
            </h3>
          </LinkWrap>
        </ContentLogin>
      </FormWrapper>
      <ImageWrapper />
    </AuthWrapper>
  );
};

export default PlayerAccessSuspended;
